// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"7418":"settings-apps-view","8351":"settings-users"}[chunkId] + "-" + chunkId + ".js?v=" + {"7418":"4d5d3e469fa54fd1570b","8351":"8d867bca10b03f10b1de"}[chunkId] + "";
};